export default __webpack_public_path__ + "static/media/thumbnail_blog_19.656d7589.jpg";